// extracted by mini-css-extract-plugin
module.exports =  {"container":"DSJnn4o45TMcief8l1SN","list":"EKm6AzlGbWOnwnr51WIw"};